module.exports = __webpack_public_path__ + "static/media/icon-rejected.c1edb597.svg";